import { PageWarningMessages } from "../../models/messages/Messages";
import "../../styles/stale/staleAlert.css";
import { Button } from "../buttons/Button";
import { useLicenseDetails } from "../licensing/useLicenseDetails";

export { PageCountWarning };

type Props = {
  onConfirm: (stale: boolean) => void;
};
/**
 * Show nothing if AcceleratorDocMetadata undefined or not stale.
 *
 * @param props
 */
const PageCountWarning = (props: Props) => {
  const [licenseDetails, loading] = useLicenseDetails();
  if (
    loading ||
    licenseDetails == undefined ||
    licenseDetails.pageCount == null ||
    licenseDetails.usage == null
  ) {
    return null;
  }

  // Page count close
  const pageCountExceeded =
    (licenseDetails?.pageCount ?? 0) < (licenseDetails?.usage ?? -1);
  const pageCountClose =
    !pageCountExceeded &&
    (licenseDetails?.pageCount ?? 0) - (licenseDetails?.usage ?? 0) <= 1000;
  // Page count exceeded or unlimited page count
  if (
    licenseDetails?.pageCount == -1 ||
    (!pageCountExceeded && !pageCountClose)
  ) {
    return null;
  }

  return (
    <div className={"staleAlert batch"}>
      {pageCountClose && <h3>The Licensed Page Count Is Nearly Reached</h3>}
      {pageCountExceeded && <h3>The Licensed Page Count Is Exceeded</h3>}
      <div>
        {pageCountClose && (
          <span>
            {PageWarningMessages.pageCountClose(
              licenseDetails!.usage ?? 0,
              licenseDetails!.pageCount ?? 0,
            )}
          </span>
        )}
        {pageCountExceeded && (
          <span>
            {PageWarningMessages.reached(licenseDetails!.pageCount ?? 0)}
          </span>
        )}

        <div className={"fluffer"} />

        {pageCountClose && (
          <div className={"buttons"}>
            <Button
              data-save-changes
              onClick={() => {
                props.onConfirm(true);
              }}
            >
              OK
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
